<!--  -->
<template>
  <div>
    <div class="serar_box search_box">
      <el-input v-model="pageIfonone.account_name" style="width: 200px;" placeholder="请输入公众号名称" />
      <el-input v-model="pageIfonone.keywords" style="width: 200px;" placeholder="请输入公众号appid/gh_id" />
      <el-select v-model="pageIfonone.onlyMe" placeholder="请选择">
        <el-option
          v-for="item in accountarr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button type="primary" icon="el-icon-refresh-left" @click="reast">重置</el-button>
    </div>
    <el-table
      ref="multipleTable"
      tooltip-effect="dark"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="app_id"
        label="公众号appid"
        width="180"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="公众号名称"
        align="center"
      />
      <el-table-column
        prop="template_send_arr"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="choose(scope.row)">选择</el-button>
        </template>
      </el-table-column>

    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { officialAccountlist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      pageIfonone: {
        page: 1,
        pageSize: 10,
        account_type: 1,
        account_name: null,
        keywords: null,
        onlyMe: 2
      },
      accountarr: [{
        value: 1,
        label: '查看组内公众号'
      }, {
        value: 2,
        label: '我关联的公众号'
      }],
      tableData: [],
      multipleSelection: [],
      total: null,
      obj: {}
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send() {
      this.getprogramlist()
    },
    // 获取绑定列表
    async getprogramlist() {
      const data = await officialAccountlist(this.pageIfonone)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfonone.pageSize = e
      this.getprogramlist()
    },
    fetchCurrentPage(e) {
      this.pageIfonone.page = e
      this.getprogramlist()
    },
    choose(item) {
      this.$emit('callback', item)
      /*      this.$emit('callback') */
    },
    search() {
      this.pageIfonone.page = 1
      this.getprogramlist()
    },
    reast() {
      this.pageIfonone.page = 1
      this.pageIfonone.pageSize = 10
      this.pageIfonone.keywords = null
      this.pageIfonone.account_name = null
      this.pageIfonone.onlyMe = 2
      this.getprogramlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.serar_box{
  margin-bottom: 10px;
}
</style>
